export default __webpack_public_path__ + "static/media/visit_image.c5c9e536.png";